THREE.Object3D.prototype.toString = function() {
    var debugString = function(object) {
        if (object.name!=null && object.name!='') {
            return object.name;
        }
        var funcNameRegex = /function (.{1,})\(/;
        var results = (funcNameRegex).exec((object).constructor.toString());
        if (results && results.length > 1 && !results[1]=='onRotationChange') {
            return results[1];
        }
        const constructor_name = _.get(object,'constructor.name');
        if (constructor_name) {
            return constructor_name;
        }
        if (object.type) {
            return object.type;
        }
        return $.type(object);
    }
    //const name = o => o.parent ? name(o.parent) + '/' + debugString(o) + '_' + o.id : debugString(o) + '_' + o.id;
    return debugString(this) + '_' + this.id;
};


THREE.Vector3.prototype.toString = function() {
    try {
        return '('+this.x.toFixed(3)+','+this.y.toFixed(3)+','+this.z.toFixed(3)+')';
    } catch (e) {
        return '('+this.x+','+this.y+','+this.z+')';
    }
};
THREE.Box3.prototype.toString = function() {
    return '('+this.min+','+this.max+')';
};
THREE.Vector2.prototype.toString = function() {
    try {
        return '('+this.x.toFixed(3)+','+this.y.toFixed(3)+')';
    } catch (e) {
        return '('+this.x+','+this.y+')';
    }
};
THREE.Box2.prototype.toString = function() {
    return '('+this.min+','+this.max+')';
};
THREE.Sphere.prototype.toString = function() {
    return '(c:'+this.center+',r:'+this.radius+')';
};
THREE.Ray.prototype.toString = function() {
    return '(o:'+this.origin+',d:'+this.direction+')';
};
THREE.Plane.prototype.toString = function() {
    return '(o:'+this.constant+',normal:'+this.normal+')';
};
THREE.Quaternion.prototype.toString = function() {
    return '('+this._x+','+this._y+','+this._z+','+this._w+')';
};
THREE.Matrix4.prototype.toString = function() {
    try {
        var el = this.elements;
        var e = (i) => (el[i]>=0?' ':'')+el[i].toFixed(2) + ' ';
        return  '\n+ ' + e(0) + e(4) + e(8)  + e(12) + ' +\n' +
            '| ' + e(1) + e(5) + e(9)  + e(13) + ' |\n' +
            '| ' + e(2) + e(6) + e(10) + e(14) + ' |\n' +
            '+ ' + e(3) + e(7) + e(11) + e(15) + ' +\n';
    } catch (e) {
        return JSON.stringify(this);
    }
};
THREE.Color.prototype.toString = function() {
    return '#'+this.getHexString();
};
THREE.Line3.prototype.toString = function() {
    return '('+this.start+','+this.end+')';
};
